module.exports = __webpack_public_path__ + "img/dea-formazione-ico-autonomia-valutazione.db5a84b5.svg";